<dx-popup (onHidden)="this.onPopupHidden()" [closeOnOutsideClick]="false"
  height="auto" maxHeight="80vh" [resizeEnabled]="true" [showCloseButton]="false"
  [title]="this.title" [width]="this.width" [wrapperAttr]="this.popupWrapperAttr">
  <div *dxTemplate="let data of 'content'" class="container" [class.acquire]="this.isAcquireMode">
    <div class="content"><div class="scroll"><div class="state">
      <ng-container *ngFor="let row of this.previewRows; let rowIx = index">
        <div class="combo-sep" *ngIf="this.multiCombo && this.isComboStart(rowIx)">{{ row.comboName || 'Unassigned' }}</div>
        <div class="section-header">{{ row.label | uppercase }}</div>
        <div class="group" [class.unchanged]="row.unchanged">
          <div class="bar"><div class="name">{{ this.underlyingTitles[rowIx] }}</div></div>
          <div class="block">
            <div class="pricing-hint" *ngIf="this.pricingHint(rowIx)">{{ this.pricingHint(rowIx) }}</div>
            <ets-order-preview-tables [tables]="this.tables[rowIx]" [isAsset]="row.isAsset"
              [acquiring]="this.isAcquireMode"
              (fillChanged)="this.onFillPxChange(rowIx, $event.index, $event.value)"></ets-order-preview-tables>
          </div>
        </div>
      </ng-container>
    </div></div></div>
    <div class="footer">
      <div class="btn" *ngIf="!this.isAcquireMode"><dx-button (onClick)="this.onCopyToTosClicked()"
        [text]="this.btnCopyTosText" type="default" width="100%"></dx-button></div>
      <div class="btn acquire">
        <dx-button *ngIf="!this.isAcquireMode" (onClick)="this.onAcquireClicked()"
          [text]="this.btnAcquireText" type="danger" width="100%"></dx-button>
        <dx-button *ngIf="this.isAcquireMode" (onClick)="this.onCompleteClicked()"
          [text]="this.btnCompleteText" [disabled]="!this.canComplete" hint="Price every leg before completing this transaction"
          type="danger" width="100%"></dx-button>
      </div>
      <div class="btn"><dx-button (onClick)="this.onCloseClicked()" [text]="this.btnCloseText" width="100%"></dx-button></div>
    </div>
  </div>
</dx-popup>
